import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class CommissionsDataService {

  constructor(private http: HttpClient,
    private dataService: DataService) { }

  getAdvancedCommissionsReportsSearch(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/Application/getAdvancedCommissionsReportsSearch', searchQuery);
  };
}
